<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="98"
    height="98"
    viewBox="0 0 98 98"
    fill="none"
  >
    <g style="mix-blend-mode: multiply">
      <path
        d="M81.939 14.1784L79.3997 13.9946L78.355 13.9185L30.4567 10.4536C28.3585 10.3015 26.5177 11.7785 26.1729 13.8107L25.4971 13.7943V13.8234L24.2902 13.7943L24.1824 18.1669L18.6016 18.4762L18.6841 19.9582L14.1162 20.5186L22.5178 88.9475L53.7916 85.1073L70.1081 86.2876C72.186 86.4385 74.0103 84.9945 74.3818 82.9927C74.4097 82.8443 74.4299 82.6935 74.4401 82.5401L74.8318 77.1139L77.73 37.0658L80.2694 37.2496C82.2509 37.3929 83.9739 35.9032 84.1171 33.9217L85.267 18.0261C85.4103 16.0433 83.9206 14.3204 81.9378 14.1771L81.939 14.1784Z"
        fill="#C6C6C6"
      />
    </g>
    <path
      d="M84.0007 16.7602L82.8509 32.6558C82.7076 34.6373 80.9847 36.1282 79.0031 35.9837L76.4637 35.7999L73.5656 75.848L73.1738 81.2742C73.1637 81.4276 73.1434 81.5784 73.1155 81.7268C72.7441 83.7286 70.9197 85.1726 68.8418 85.0217L23.9393 81.7737C21.708 81.6127 20.0307 79.6729 20.193 77.4416L24.2841 20.8958L24.8077 13.6478L24.8597 12.934C25.0207 10.7027 26.9604 9.02546 29.1917 9.18647L77.09 12.6513L78.1347 12.7274L80.6741 12.9112C82.6556 13.0545 84.1465 14.7774 84.0033 16.7602H84.0007Z"
      fill="#FBB040"
    />
    <g style="mix-blend-mode: multiply">
      <path
        d="M24.2358 12.5301L22.5688 80.2551L72.2131 81.4771L73.8801 13.7521L24.2358 12.5301Z"
        fill="#E6E7E8"
      />
    </g>
    <path
      d="M23.0273 12.5306L21.3604 80.2556L71.0046 81.4776L72.6716 13.7526L23.0273 12.5306Z"
      fill="white"
    />
    <path
      d="M66.9187 14.4625L17.3354 17.2086L21.0817 84.8505L70.665 82.1044L66.9187 14.4625Z"
      fill="#F1F2F2"
    />
    <path
      d="M63.7723 13.0007L12.8486 19.2533L21.2506 87.6817L72.1743 81.4291L63.7723 13.0007Z"
      fill="white"
    />
    <path
      d="M56.8718 17.5848L20.6543 22.0317L21.0948 25.6193L57.3123 21.1723L56.8718 17.5848Z"
      fill="#C3D5DF"
    />
    <path
      d="M60.3455 29.9682L19.21 34.4604L19.449 36.1919L60.5845 31.6997L60.3455 29.9682Z"
      fill="#DAE3E8"
    />
    <path
      d="M40.8214 35L19.5005 37.3284L19.7395 39.0598L41.0604 36.7315L40.8214 35Z"
      fill="#DAE3E8"
    />
    <path
      d="M52.8212 27.2742L19.3569 30.9287L19.596 32.6602L53.0602 29.0057L52.8212 27.2742Z"
      fill="#8BCFCA"
    />
    <path
      d="M62.0323 43.4919L21.2363 48.501L21.4489 50.2325L62.2449 45.2233L62.0323 43.4919Z"
      fill="#DAE3E8"
    />
    <path
      d="M56.1882 47.7102L22.082 51.8979L22.2946 53.6294L56.4008 49.4417L56.1882 47.7102Z"
      fill="#DAE3E8"
    />
    <path
      d="M55.3389 40.7993L20.5464 45.0713L20.759 46.8028L55.5515 42.5308L55.3389 40.7993Z"
      fill="#8BCFCA"
    />
    <path
      d="M63.6928 57.0162L24.2231 61.8624L24.4357 63.5939L63.9054 58.7476L63.6928 57.0162Z"
      fill="#DAE3E8"
    />
    <path
      d="M57.8494 61.234L24.7075 65.3033L24.9201 67.0348L58.062 62.9655L57.8494 61.234Z"
      fill="#DAE3E8"
    />
    <path
      d="M57.0009 54.3227L23.2368 58.4684L23.4494 60.1999L57.2135 56.0541L57.0009 54.3227Z"
      fill="#8BCFCA"
    />
    <path
      d="M65.3535 70.5388L26.7114 75.2834L26.924 77.0149L65.5661 72.2703L65.3535 70.5388Z"
      fill="#DAE3E8"
    />
    <path
      d="M59.5087 74.757L27.6089 78.6738L27.8215 80.4053L59.7213 76.4885L59.5087 74.757Z"
      fill="#DAE3E8"
    />
    <path
      d="M58.6593 67.8458L25.9531 71.8616L26.1657 73.593L58.8719 69.5772L58.6593 67.8458Z"
      fill="#8BCFCA"
    />
    <g style="mix-blend-mode: multiply">
      <path
        d="M70.8146 81.7706L53.6 65.0854C52.0801 63.6099 49.7538 63.4327 47.864 64.4762C47.8994 64.4562 47.9349 64.4341 47.9703 64.4141L43.6545 60.2312C49.5322 52.8845 49.0005 42.1304 42.1346 35.4062L43.6943 39.2236L45.1765 51.9629L38.0403 61.6913L29.1538 64.3676L20.7526 62.7037L16.1753 61.9084C23.0124 68.6081 33.7223 68.9405 40.9449 62.9785L45.3848 67.281C45.3648 67.3342 45.3471 67.3874 45.3272 67.4427C45.2984 67.5225 45.2674 67.6023 45.243 67.6842C45.2186 67.7662 45.1987 67.8504 45.1765 67.9324C45.1566 68.0099 45.1366 68.0853 45.1211 68.1628C45.1012 68.2492 45.0901 68.3378 45.0768 68.4242C45.0658 68.4996 45.0525 68.5727 45.0436 68.648C45.0347 68.7366 45.0303 68.823 45.0259 68.9116C45.0214 68.9848 45.0148 69.0601 45.0148 69.1332C45.0148 69.1553 45.0104 69.1775 45.0104 69.2019C45.0104 69.275 45.017 69.3459 45.0214 69.4212C45.0237 69.481 45.0237 69.5409 45.0303 69.6007C45.0369 69.6959 45.0502 69.7912 45.0635 69.8887C45.0724 69.9463 45.079 70.0061 45.0901 70.0637C45.1056 70.159 45.13 70.2543 45.1522 70.3473C45.1654 70.4049 45.1787 70.4625 45.1943 70.5179C45.2208 70.6132 45.2541 70.7062 45.2873 70.7993C45.305 70.8524 45.3227 70.9078 45.3427 70.9588C45.3804 71.0563 45.4247 71.1493 45.469 71.2424C45.4933 71.2889 45.5111 71.3377 45.5354 71.3842C45.5886 71.4839 45.6484 71.5791 45.706 71.6766C45.7304 71.7143 45.7503 71.752 45.7747 71.7896C45.8478 71.9004 45.9298 72.0089 46.014 72.1131C46.0295 72.133 46.0428 72.153 46.0561 72.1707C46.1602 72.2948 46.2688 72.4144 46.3862 72.5274L63.6008 89.2125C65.1074 90.6725 67.4005 90.8609 69.2792 89.8506C69.7711 89.5891 70.2341 89.248 70.6462 88.8226C72.638 86.7688 72.7133 83.6094 70.8146 81.7706ZM45.531 66.9553C45.5044 67.0129 45.4756 67.0661 45.4512 67.1237C45.4889 67.0395 45.5244 66.9575 45.5665 66.8756C45.5554 66.9022 45.5421 66.9288 45.531 66.9553ZM45.7924 66.4724C45.7503 66.541 45.7083 66.6075 45.6706 66.6762C45.7348 66.561 45.8013 66.4458 45.8744 66.3328C45.8434 66.3793 45.819 66.4258 45.7924 66.4724ZM46.127 65.9805C46.0915 66.0248 46.0583 66.0691 46.0251 66.1134C46.0782 66.0381 46.1314 65.965 46.189 65.8919C46.1669 65.9207 46.1491 65.9517 46.127 65.9805Z"
        fill="#C6C6C6"
      />
    </g>
    <path
      d="M69.5375 87.7143C71.5293 85.6582 71.6046 82.5011 69.7059 80.66L52.4913 63.9749C50.5926 62.1338 47.4377 62.3088 45.4459 64.3626C43.4542 66.4164 43.3788 69.5757 45.2775 71.4168L62.49 88.102C64.3887 89.9409 67.5436 89.7681 69.5353 87.7121L69.5375 87.7143Z"
      fill="#1E6A56"
    />
    <g style="mix-blend-mode: multiply">
      <path
        d="M69.5379 87.7154C67.5462 89.7714 64.3913 89.9442 62.4926 88.1053L45.2801 71.4202C44.3607 70.5296 43.9043 69.3287 43.9043 68.0925C43.9043 66.7787 44.4227 65.4272 45.4507 64.366L69.5401 87.7132L69.5379 87.7154Z"
        fill="#EDEDED"
      />
    </g>
    <path
      d="M46.8614 63.3072C46.3541 63.5731 45.8733 63.9254 45.4479 64.3663C44.9251 64.9069 44.5329 65.5228 44.2759 66.1741L38.7637 60.8303C39.2954 60.3916 39.805 59.9175 40.2968 59.4168C40.7156 58.9914 41.1099 58.5483 41.4843 58.0963L46.8614 63.3072Z"
      fill="#2C4761"
    />
    <path
      d="M15.0684 60.8005C22.3862 67.9699 34.133 67.8481 41.3024 60.5302C48.4696 53.2123 48.3478 41.4678 41.0277 34.2984C33.712 27.1289 21.9653 27.2508 14.7958 34.5686C7.62862 41.8865 7.75269 53.631 15.0684 60.8005ZM17.0712 36.7952C23.011 30.7314 32.7394 30.6317 38.8033 36.5715C44.8672 42.5091 44.9647 52.2397 39.027 58.3014C33.0894 64.3653 23.3589 64.4649 17.295 58.5251C11.2311 52.5875 11.1314 42.8591 17.0712 36.7952Z"
      fill="#32526F"
    />
    <path
      d="M12.2905 46.6326C12.7601 37.8857 20.2619 31.1549 29.0066 31.6246C37.7535 32.0943 44.4843 39.5939 44.0146 48.3407C43.5427 57.0876 36.0453 63.8206 27.2984 63.3487C18.5537 62.8768 11.8185 55.3795 12.2905 46.6326ZM13.0349 46.6725C12.5851 55.0095 19.0013 62.159 27.3383 62.6087C35.6775 63.0585 42.8248 56.6401 43.2746 48.3031C43.7243 39.9661 37.3059 32.8188 28.9667 32.369C20.6297 31.9193 13.4824 38.3377 13.0349 46.6747V46.6725Z"
      fill="#414042"
    />
    <g style="mix-blend-mode: multiply" opacity="0.61">
      <path
        d="M43.2757 48.3002C43.7254 39.9632 37.307 32.8159 28.9678 32.3661C20.6308 31.9164 13.4835 38.3348 13.0359 46.6718C12.5862 55.0088 19.0024 62.1583 27.3394 62.6081C35.6786 63.0578 42.8259 56.6394 43.2757 48.3024V48.3002Z"
        fill="#D3EAEB"
      />
    </g>
    <g style="mix-blend-mode: lighten">
      <g style="mix-blend-mode: screen">
        <path
          d="M13.9885 52.8264L33.4962 33.3165C32.0805 32.7803 30.5584 32.4502 28.9677 32.366C28.7129 32.3527 28.4581 32.3461 28.2033 32.3439L13.0137 47.5335C13.0181 49.3879 13.3615 51.1736 13.9863 52.8264H13.9885Z"
          fill="#706F6F"
        />
      </g>
      <g style="mix-blend-mode: screen">
        <path
          d="M17.3618 58.0943L38.7638 36.6923C38.2166 36.1539 37.6317 35.6577 37.0069 35.2057L15.8774 56.3352C16.3272 56.9577 16.8235 57.547 17.3618 58.0943Z"
          fill="#706F6F"
        />
      </g>
    </g>
  </svg>
</template>
